export const ADD_SLIDE_TO_SPLIT_SYNC_VIEW = "ADD_SLIDE_TO_SPLIT_SYNC_VIEW";

export const CLEAR_ALL_SLIDES_FROM_SPLIT_SYNC_VIEW = "CLEAR_ALL_SLIDES_FROM_SPLIT_SYNC_VIEW";

export const REPLACE_SLIDES_IN_SPLIT_SYNC_VIEW = "REPLACE_SLIDES_IN_SPLIT_SYNC_VIEW";

